// extracted by mini-css-extract-plugin
module.exports = {"root":"TransportsExpandedRow_root__19v7U","firstCol":"TransportsExpandedRow_firstCol__1KDfx"};